'use client';
import SectionHeader from '@/app/(website)/components/SectionHeader';
import { Body } from '@/components/body';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import AutoScroll from 'embla-carousel-auto-scroll';
import { useEffect, useRef, useState } from 'react';

const ROLES_1 = [
  'Amministratori di Condominio',
  'Studi di amministrazione condominiale',
  'Società di gestione immobiliare',
  'Collaboratori e assistenti di studio',
  'Società di property management',
  'Società di facility management',
  'Revisori condominiali',
  'Consulenti immobiliari',
  'Asset manager immobiliari',
  'Real estate manager',
  'Società di gestione locativa',
];

const ROLES_2 = [
  'Property administrator',
  'Tecnici fiduciari di condomini',
  'Consulenti per bonus edilizi',
  'Responsabili ufficio tecnico',
  'Società di servizi per condomini',
  'Avvocati condominialisti',
  'Consulenti legali real estate',
  'Commercialisti specializzati in condomini',
  'Revisori contabili immobiliari',
  'Consulenti assicurativi immobiliari',
  'Consulenti ESG real estate',
];

export default function PotentialMarketCondominio() {
  const [isVisible, setIsVisible] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.1,
      },
    );

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, []);

  const potentialClient = (role: string, index: number) => {
    return (
      <CarouselItem className="basis-auto" key={index}>
        <div className="bg-background-4 rounded-full px-8 py-4 flex items-center justify-center whitespace-nowrap w-fit min-w-[12rem]">
          <Body variant="bold" className="text-nowrap">
            {role}
          </Body>
        </div>
      </CarouselItem>
    );
  };
  return (
    <div className="flex flex-col w-full items-center gap-10 py-16">
      <SectionHeader
        badgeText="CHI USA NORMO.AI"
        title={
          <>
            Ideato per il lavoro quotidiano dell'
            <br />
            <span className="rounded-[2rem] rounded-br-[8px] py-0 px-2 md:px-4 bg-secondary text-primary">
              Amministratore di Condominio
            </span>
          </>
        }
        subtitle={
          'Normo.ai è particolarmente utile dove la gestione immobiliare richiede continua ricerca legale, analisi di contratti, redazione di atti e comunicazioni tempestive ai condomini.'
        }
        titleAnimationStart="bottom"
        className="px-8"
      />
      <div
        className="flex flex-col gap-4 md:gap-6 relative max-w-full overflow-x-hidden"
        ref={contentRef}
      >
        <Carousel
          className={`w-full transition-all duration-1000 ease-in-out transform ${
            isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-40'
          }`}
          opts={{loop: true}}
          plugins={[
            AutoScroll({
              direction: 'forward',
              speed: 0.8,
              stopOnInteraction: false,
            }),
          ]}
        >
          <CarouselContent>
            {ROLES_1.map((role, index) => potentialClient(role, index))}
          </CarouselContent>
        </Carousel>
        <Carousel
          className={`w-full transition-all duration-1000 ease-in-out transform ${
            isVisible
              ? 'opacity-100 translate-x-0'
              : 'opacity-0 -translate-x-40'
          }`}
          opts={{loop: true}}
          plugins={[
            AutoScroll({
              direction: 'backward',
              speed: 0.8,
              stopOnInteraction: false,
            }),
          ]}
        >
          <CarouselContent>
            {ROLES_2.map((role, index) => potentialClient(role, index))}
          </CarouselContent>
        </Carousel>
        <div className="absolute inset-0 bg-gradient-to-r from-white via-transparent to-white pointer-events-none" />
      </div>
    </div>
  );
}
